import clsx from 'clsx'
import { memo } from 'react'
//import $ from './style.module.scss'

const Buttons = () => {
  return (
    <div className={''}>
      <div className={clsx('')}>Delete All</div>
      <div className={clsx('', '')}>Apply</div>
    </div>
  )
}

export default memo(Buttons)
